import React from 'react'
import { ProductAgreementType } from 'config/products'
import { FlowActions } from '../components'
import SharedSelectCompanyInformationForm from '../../products/forms/SelectCompanyInformationForm'

function SelectCompanyInformationForm(props) {
  return (
    <SharedSelectCompanyInformationForm
      {...props}
      FlowActionsComponent={FlowActions}
      agreementsType={ProductAgreementType.BD}
    />
  )
}

export default React.memo(SelectCompanyInformationForm)
